import { createSelector } from 'reselect';
import { getKaMetlhaFuneralCover } from './index';
import {
    extendedFamilyRelations,
    getQuoteRefernceData,
    getTermsAndConditions,
    isAgentCodeValue,
    parentsInLawsRelations,
} from './referenceData';
import { KMF_COVER_CATEGORIES, RELATIONS } from '../../actions/kaMetlhaFuneralCover/types';
import { quotaionMockData, paidUpMock } from '../../mocks/kaMethlaFuneralCover/quote';
import { FORM_STATUS } from '../../reducers/status';
import { getPurchasePersonalDetailsForm } from './personalDetails';
import { getBankingDetailsForm } from './bankingDetails';
import { getUploadDocumentForm } from './uploadDocuments';
// import { quotaionMockData } from '../../mocks/kaMetlhaFuneralCover/quote';

export const getQuote = createSelector(getKaMetlhaFuneralCover, (kaMetlhaFuneralCover) => kaMetlhaFuneralCover.quote);
import { getQuoteResponse } from '@om/redux/selectors/kaMetlhaFuneralCover/referenceData';
export const getSelectedCoverCategory = createSelector(getQuote, (quote) => quote?.selectedCoverCategory);
export const getCoverType = createSelector(getQuote, (quote) => quote.coverType);
export const getDeleteQuoteDetails = createSelector(getQuote, (quote) => quote.deleteQuoteDetails);
export const getEditQuoteDetails = createSelector(getQuote, (quote) => quote.editQuoteDetails);
export const getQuoteForm = createSelector(getQuote, (quote) => quote.form);
export const getPopupModalValue = createSelector(getQuote, (quote) => quote?.popupModalDetails);
export const getLivesCovered = createSelector(getQuote, (quote) => quote.livesCovered);
export const getBeneficiaryForm = createSelector(getLivesCovered, (livesCovered) =>
    Object.values(livesCovered[KMF_COVER_CATEGORIES.BENEFECIARY])
);
export const getBenefitsDetails = createSelector(
    getLivesCovered,
    (livesCovered) => Object.values(livesCovered[KMF_COVER_CATEGORIES.BENIFITS])[0] ?? {}
);
export const getIsOnInitPage = createSelector(getQuote, (quote) => {
    return !Object.values(quote.livesCovered).some((element) => Object.values(element).length);
});
export const getMainMemberDetails = createSelector(
    getLivesCovered,
    (livesCovered) => Object.values(livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY])[0]
);
export const getProductCodeSelected = createSelector(getLivesCovered, (livesCovered) =>
    Object.values(livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]).length > 1
        ? KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY
        : KMF_COVER_CATEGORIES.MYSELF
);
//Parents In Lows Dropdown disabled logic
export const getDisplayParentCoverOptions = createSelector(
    getLivesCovered,
    getQuoteRefernceData,
    (livesCovered, parentOptions) => {
        return parentOptions?.displayParentsandInLaws?.map(({ code, description }) => ({
            code: code,
            description: description,
            disabled: Object.values(livesCovered[KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS]).some(
                (ele) => ele.relationship.value === code
            ),
        }));
    }
);
//Cover Categories Disabled logic

const beneficiaryRelations = [
    'Mother',
    'Mother-in-law',
    'Father',
    'Father-in-law',
    'Father-in-law',
    'Brother',
    'Sister',
];
export const getLivesCoveredMembersList = createSelector(getLivesCovered, (livesCovered) => {
    const allMembers = {
        ...livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY],
        ...livesCovered[KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS],
        ...livesCovered[KMF_COVER_CATEGORIES.EXTENDED_FAMILY],
    };
    return Object.keys(allMembers)?.flatMap((member) =>
        allMembers[member].relationship.value === 'Myself' || allMembers[member].age.value < 18
            ? []
            : { id: member, name: allMembers[member]?.firstName.value + ' ' + allMembers[member]?.surname.value }
    );
});

export const getMonthlyPremiumQuote = createSelector(getQuoteForm, (quoteForm) => {
    const { age, coverAmount, selectedCoverCategory } = quoteForm;
    const premiumCategory = quotaionMockData[selectedCoverCategory.value];

    if (premiumCategory && coverAmount.value) {
        return (
            premiumCategory[coverAmount.value]?.filter(
                ({ minAge, maxAge }) => age.value >= minAge && age.value <= maxAge
            )[0]?.premium ?? 0
        );
    } else return 0;
});

export const calculatePremium = (category, age, coverAmount) =>
    quotaionMockData[category][coverAmount]?.filter(({ minAge, maxAge }) => age >= minAge && age <= maxAge)[0]
        ?.premium ?? 0;

export const getFinalQuotation = createSelector(
    getLivesCovered,
    getMainMemberDetails,
    (livesCovered, mainMemberDetails) => {
        const benifits = Object.values(livesCovered[KMF_COVER_CATEGORIES.BENIFITS])[0];
        const cashbackDetails = benifits?.benefitsDetails?.value === 'Yes';
        const paidUpDetails = benifits?.benefitsDetailsOnPremium?.value === 'Yes';
        const { age, monthlyPremium } = mainMemberDetails;
        const percentage =
            paidUpMock.filter(({ minAge, maxAge }) => age.value >= minAge && age.value <= maxAge)[0]?.charge ?? 0;
        const costWithoutBenefits = Object.values(livesCovered)
            ?.flatMap((item) => Object.values(item))
            ?.reduce((acc, curr) => acc + curr.monthlyPremium.value, 0);

        const paidup = paidUpDetails
            ? costWithoutBenefits + (monthlyPremium?.value / 100) * percentage
            : costWithoutBenefits;
        const cashback = cashbackDetails ? paidup + (paidup / 100) * 8.6 : paidup;
        return cashback.toFixed(2);
    }
);

export const getMainCoverAmount = createSelector(
    getLivesCovered,
    (livesCovered) =>
        Object.values(livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY])?.filter(
            (item) => item.relationship.value === RELATIONS.MYSELF
        )[0]?.coverAmount.value ?? 0
);
export const isSpouseIncudedwithMainMember = createSelector(getLivesCovered, (livesCovered) =>
    Object.values(livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY])?.some(
        ({ relationship }) => relationship.value === RELATIONS.SPOUSE
    )
);
export const isChildIncudedwithMainMember = createSelector(getLivesCovered, (livesCovered) =>
    Object.values(livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY])?.some(
        ({ relationship }) => relationship.value === RELATIONS.CHILD
    )
);
//Cover Categories Disabled logic
export const getLivesCoveredCategoryOptions = (withChild) =>
    createSelector(getLivesCovered, getQuoteRefernceData, (livesCovered) => {

        const membersCount = {
            [RELATIONS.SPOUSE]: [
                ...Object.values(livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]),
                ...Object.values(livesCovered[KMF_COVER_CATEGORIES.EXTENDED_FAMILY]),
            ]?.some(({ relationship }) => relationship.value === RELATIONS.SPOUSE),
            [RELATIONS.CHILD]:
                Object.values(livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY])?.filter(
                    ({ relationship }) => relationship.value === RELATIONS.CHILD
                ).length === 6,
            [KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS]:
                Object.values(livesCovered[KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS])?.length === 4,
            [KMF_COVER_CATEGORIES.EXTENDED_FAMILY]:
                Object.values(livesCovered[KMF_COVER_CATEGORIES.EXTENDED_FAMILY])?.length === 6,
        };
        return [
            ...(withChild
                ? [
                      {
                          code: 'Child',
                          description: 'Child',
                          disabled: membersCount.Child,
                      },
                      {
                          code: 'Spouse',
                          description: 'Spouse',
                          disabled: membersCount.Spouse,
                      },
                  ]
                : []),
            {
                code: KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS,
                description: 'My Parents and Parents In-law',
                disabled: membersCount[KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS],
            },
            {
                code: KMF_COVER_CATEGORIES.EXTENDED_FAMILY,
                description: 'My Extended Family',
                disabled: membersCount[KMF_COVER_CATEGORIES.EXTENDED_FAMILY],
            },
        ];
    });

export const getLivesCoveredFormStatus = createSelector(getLivesCovered, (livesCovered) => {
    const membersCovered = [
        livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY],
        livesCovered[KMF_COVER_CATEGORIES.EXTENDED_FAMILY],
        livesCovered[KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS],
    ];
    return membersCovered
        .flatMap((member) => Object.values(member))
        .every((item) => item?.formStatus?.value === FORM_STATUS.VALID);
});
export const getDirectFamilyMemberDetailsAdded = createSelector(getLivesCovered, (livesCovered) =>
    Object.values(livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY])
        .filter((member) => member.relationship !== RELATIONS.MYSELF)
        .some((member) => member.firstName.value)
);
export const getHighestCoverAmount = createSelector(getLivesCovered, (livesCovered) => {
    const allMembersCoverAmount = Object.values({
        ...livesCovered[KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS],
        ...livesCovered[KMF_COVER_CATEGORIES.EXTENDED_FAMILY],
    }).map((member) => member.coverAmount.value);

    return Math.max(...allMembersCoverAmount);
});

const inputFieldLabels = {
    id: 'ID Number',
    dateOfBirth: 'Date Of Birth',
    relationship: 'Relationship',
    cellphone: 'Cell Phone Number',
    email: 'Email Address',
};

export const getBenificiaryDetailsSummary = createSelector(getBeneficiaryForm, (beneFiciaryForm) => {
    const fullName = beneFiciaryForm[0]['firstName']?.value + ' ' + beneFiciaryForm[0]['surname']?.value;
    const beneficiaryDetails = Object.keys(beneFiciaryForm[0])
        ?.flatMap((item) => {
            if (!Object.keys(inputFieldLabels).includes(item)) return;
            return {
                label: inputFieldLabels[item],
                value: beneFiciaryForm[0][item]?.value ?? '-',
            };
        })
        .filter((item) => item !== undefined);
    return [
        {
            label: 'Beneficiary Name',
            value: fullName,
        },
        ...beneficiaryDetails,
    ];
});

export const getLivesCoveredSummary = createSelector(
    getLivesCovered,
    getPurchasePersonalDetailsForm,
    (livesCovered, personalDetail) => {
        const fullName =
            personalDetail?.title?.value +
            ' ' +
            personalDetail?.firstName?.value +
            ' ' +
            personalDetail?.surname?.value;
        const allMembers = {
            ...livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY],
            ...livesCovered[KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS],
            ...livesCovered[KMF_COVER_CATEGORIES.EXTENDED_FAMILY],
        };

        return Object.keys(allMembers)?.flatMap((member) => ({
            id: member,
            fullName:
                allMembers[member]?.relationship?.value !== 'Myself'
                    ? allMembers[member]?.title?.value +
                      ' ' +
                      allMembers[member]?.firstName?.value +
                      ' ' +
                      allMembers[member]?.surname?.value
                    : fullName,
            relationship: allMembers[member]?.relationship?.value,
            coverAmount: allMembers[member]?.coverAmount?.value ?? '-',
            monthlyPremium: allMembers[member]?.monthlyPremium?.value ?? '-',
        }));
    }
);

export const getPlanDetailsSummary = createSelector(
    getQuoteResponse,
    getLivesCovered,
    (quoteValue, livesCovered) => {
        const { funeralPremium: quoteSummary } = quoteValue || {};

        return [
            {
                label: 'Plan Name ',
                value: `Ka-Metlha Funeral Cover ${
                    Object.keys(livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]).length > 1
                        ? '(Me & My Direct Family)'
                        : '(Myself)'
                }`,
            },
            {
                label: 'Premium Frequency',
                value: 'Monthly',
            },
            {
                label: 'Premium Contribution',
                value: quoteSummary ? `P ${(+quoteSummary).toFixed(2)}` : '',
            },
        ];
    }
);

export const getBenefitDetailsSummary = createSelector(getBenefitsDetails, (benefitDetails) => {
    const benefitsLabel = {
        benefitsDetails: 'Cash Back',
        // benefitsDetailsOnPremium: 'Premium Paid Up',
    };
    return Object.keys(benefitDetails)
        ?.flatMap((item) => {
            if (!Object.keys(benefitsLabel).includes(item)) return;
            return {
                label: benefitsLabel[item],
                value: benefitDetails[item]?.value ?? '-',
            };
        })
        .filter((item) => item !== undefined);
});

export const getBooleanValue = (value) => value?.toLowerCase() === 'yes';

export const getPurchaseDetailsRequestBody = createSelector(
    getPurchasePersonalDetailsForm,
    getLivesCovered,
    getBeneficiaryForm,
    getBankingDetailsForm,
    getUploadDocumentForm,
    getTermsAndConditions,
    getBenefitsDetails,
    isAgentCodeValue,
    (personalDetails, livesCovered, beneFiciaryForm, bankingDetails, documentDetails, tandCDetails, benifitAdded,agentCode) => {
        const firstName = personalDetails?.firstName?.value;
        const lastName = personalDetails?.surname?.value;
        const personalDetailsPayload = {
            title: personalDetails?.title?.value,
            firstName: firstName,
            lastName: lastName,
            nationality: personalDetails?.nationality?.value,
            birthCountry: personalDetails?.birthCountry?.value,
            agentCode: agentCode || '',
            botswanaIdNumber: personalDetails?.id?.value,
            dateOfBirth: personalDetails?.dateOfBirth?.value?.replaceAll('/', '-'),
            idExpiryDate: personalDetails?.expiryDate?.value?.replaceAll('/', '-'),
            isPip: getBooleanValue(personalDetails?.prominentPerson?.value),
            email: personalDetails?.email?.value,
            contactNumber: personalDetails?.mobileNumber?.value,
            residentialAddress: {
                addressLine1: personalDetails?.streetAddress?.value,
                city: personalDetails?.city?.value,
                country: personalDetails?.country?.value,
            },
            postalAddress: {
                addressLine1: personalDetails?.postalSuburb?.value,
                city: personalDetails?.postalCity?.value,
                country: personalDetails?.postalCountry?.value,
            },
            previousResidentialAddress: {
                addressLine1: personalDetails?.previousPostalAddress?.value ?? '',
                city: personalDetails?.previousPostalCity?.value ?? '',
                country: personalDetails?.previousPostalCountry?.value ?? '',
            },
            employmentDetails: {
                status: personalDetails?.employementType?.value,
                occupation: personalDetails?.employeeOccupation?.value,
                sourceOfIncome: personalDetails?.sourceOfIncome?.value,
            },
        };
        const allMembers = {
            ...livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY],
            ...livesCovered[KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS],
            ...livesCovered[KMF_COVER_CATEGORIES.EXTENDED_FAMILY],
        };
        const livesCoveredPayload = Object.keys(allMembers)?.flatMap((member) => ({
            relationship: extendedFamilyRelations.some(
                (item) => item?.description === allMembers[member]?.relationship?.value
            )
                ? 'My_Extended_Family'
                : parentsInLawsRelations.some((item) => item?.description === allMembers[member]?.relationship?.value)
                ? 'MyParents_and_In-laws'
                : allMembers[member]?.relationship?.value,
            title: allMembers[member]?.title?.value,
            firstName: allMembers[member]?.firstName?.value,
            lastName: allMembers[member]?.surname?.value,
            dateOfBirth: allMembers[member]?.dateOfBirth?.value?.replaceAll('/', '-'),
            nationality: allMembers[member]?.nationality?.value,
            botswanaId: allMembers[member]?.id?.value === "" ? null : allMembers[member]?.id?.value,
            coverAmount: allMembers[member]?.coverAmount?.value,
            isStudent: getBooleanValue(allMembers[member]?.childIsStudent?.value),
            hasSpecialNeeds: getBooleanValue(allMembers[member]?.childHaveSpecialNeed?.value),
            familyMember: allMembers[member]?.relationship?.value,
        }));

        const beneficiariesPayload = {
            name: beneFiciaryForm[0]?.firstName?.value,
            lastName: beneFiciaryForm[0]?.surname?.value,
            nationalId: beneFiciaryForm[0]?.id?.value,
            dateOfBirth: beneFiciaryForm[0]?.dateOfBirth?.value?.replaceAll('/', '-'),
            relationship: beneFiciaryForm[0]?.relationship?.value,
            mobileNumber: personalDetails?.mobileNumber?.value,
            // addressLine1: beneFiciaryForm?.fileName?.value,
            // addressLine2: beneFiciaryForm?.fileName?.value,
            // city: beneFiciaryForm?.fileName?.value,
            email: beneFiciaryForm[0]?.email?.value,
            title: beneFiciaryForm[0]?.title?.value,
            // percentageBenefit: 100,
            nationality: beneFiciaryForm[0]?.nationality?.value,
        };

        const paymentPayload = {
            bankName: bankingDetails?.bankName?.value,
            branchName: bankingDetails?.branchCode?.value,
            accountHolderName: bankingDetails?.accountHolder?.value,
            accountNumber: bankingDetails?.accountNumber?.value?.replaceAll(' ', ''),
            accountType: bankingDetails?.accountType?.displayValue,
            debitOrderDate: bankingDetails?.debitOrderDay?.value,
            confirmDetails: bankingDetails?.paymentAuthorization?.value,
        };
        const inputFieldLabels = {
            certifiedCopyOfId: 'Your ID',
            incomeProof: 'Proof of income statement',
            addressProof: 'Proof of address',
            bankStatement: 'Bank statement',
        };
        const benifit = {
            premiumPaidUp: false,
            cashBack: benifitAdded?.benefitsDetails?.value === 'Yes' ? true : false,
        };
        const documentsPayload = Object.keys(documentDetails)
            .map((key) => {
                  const currentUrlSplited=documentDetails[key]?.url?documentDetails[key]?.url.split("file/"):["",""]
                return {
                    documentType: inputFieldLabels[key],
                    fileName: documentDetails[key]?.fileName,
                    fileType: 'image/png',
                    fileSize: 2048000,
                    url:  currentUrlSplited[0]+'file/'+encodeURIComponent(currentUrlSplited[1]),
                };
            })
            .filter((item) => item?.fileName);
        return {
            coverType:
                Object.keys(livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]).length > 1
                    ? 'Me_And_My_Direct_Family'
                    : KMF_COVER_CATEGORIES.MYSELF,
            benifit: benifit,
            personalDetails: personalDetailsPayload,
            livesCovered: livesCoveredPayload,
            beneficiaries: [beneficiariesPayload],
            paymentDetails: paymentPayload,
            uploadDocuments: [],
            uploadDocuments: documentsPayload, 
            confirmDetails: tandCDetails,
        };
    }
);

export const getMaxCountOfAllmembers = createSelector(getLivesCovered, (livesCovered) => {
    const allMembers = {
        ...livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY],
        ...livesCovered[KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS],
        ...livesCovered[KMF_COVER_CATEGORIES.EXTENDED_FAMILY],
    };
    return Object.keys(allMembers).filter((member) => allMembers[member]?.age?.value > 18).length;
});

export const getMaxCountOfAllmembersQuote = createSelector(getLivesCovered, (livesCovered) => {
    const allMembers = {
        ...livesCovered[KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS],
        ...livesCovered[KMF_COVER_CATEGORIES.EXTENDED_FAMILY],
    };
    return Object.keys(allMembers).length;
});

export const getValueWithThousandSeperator = (amount) => {
    let decimalSeperate = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimalSeperate;
};

const categoryKeys = {
    [KMF_COVER_CATEGORIES.EXTENDED_FAMILY]: 'MyExtendedFamily',
    [KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS]: 'MyParentsOrInLaws',
};
const getValidDOB = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 17);

    // Formatting as DD/MM/YYYY
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = today.getFullYear();

    return `${day}/${month}/${year}`;
};

export const getQuoteRequestBody = createSelector(
    getMainMemberDetails,
    getLivesCovered,
    getBenefitsDetails,
    isSpouseIncudedwithMainMember,
    isChildIncudedwithMainMember,
    (mainMember, livesCovered, benifitsDetails, isSpouseIncudedwithMainMember, isChildIncudedwithMainMember) => {
        const { dateOfBirth, addPartner, addChild, coverAmount, title } = mainMember;
        const getAdditionalMembers = (category) =>
            Object.keys(livesCovered[category])?.map((memberKey) => {
                const { dateOfBirth, coverAmount, relationship } = livesCovered[category][memberKey];
                return {
                    id: memberKey,
                    familyMemberType: categoryKeys[category],
                    familyMemberRelation:
                        category === KMF_COVER_CATEGORIES.EXTENDED_FAMILY && relationship.value === RELATIONS.SPOUSE
                            ? RELATIONS.WIFE
                            : relationship.value,
                    dateOfBirth: dateOfBirth.value,
                    coverAmount: +coverAmount.value,
                };
            });
        const allMembersParentinLaws = getAdditionalMembers(KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS);
        const allMembersExtendedFamily = getAdditionalMembers(KMF_COVER_CATEGORIES.EXTENDED_FAMILY);
        const childDOB = getValidDOB();
        // Child Special needs and Student changes
        const childDetails = Object.values(livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY])
            .map((item) => {
                const child = {
                    ...item,
                    childIsStudent: {
                        ...item.childIsStudent,
                        value: item.childIsStudent.value === 'Yes' ? 'CHECKED' : 'UNCHECKED',
                    },
                    childHaveSpecialNeed: {
                        ...item.childHaveSpecialNeed,
                        value: item.childHaveSpecialNeed.value === 'Yes' ? 'CHECKED' : 'UNCHECKED',
                    },
                };
                return child;
            })
            .filter(({ relationship }) => relationship?.value === 'Child');

        let childDetailPayload = [];

        for (let key in childDetails) {
            let childData = childDetails[key];
            childDetailPayload.push({
                dateOfBirth: childData.dateOfBirth.value ?? childDOB,
                specialNeeds: childData.childHaveSpecialNeed.value ?? 'UNCHECKED',
                student: childData.childIsStudent.value ?? 'UNCHECKED',
            });
        }

        return {
            dateOfBirth: dateOfBirth?.value,
            gender: title?.value === 'Mr.' ? 'male' : 'female',
            spouseCovered: isSpouseIncudedwithMainMember,
            spouseDateOfBirth: dateOfBirth?.value,
            childrenCovered: isChildIncudedwithMainMember,
            childrenDetails: childDetailPayload,
            paymentFrequency: 'monthly',
            benefitsApplied: {
                cashback: benifitsDetails?.benefitsDetails?.value === 'Yes' ? true : false,
                premiumPaidUp: false,
            },
            additionalCoverMembers: [...allMembersParentinLaws, ...allMembersExtendedFamily],
            coverAmount: +coverAmount?.value,
        };
    }
);

export const getLeadMailPayload = createSelector(getLivesCovered, (livesCovered) => {
    const getAdditionalMembers = (category) => {
        const members = livesCovered[category]; // This retrieves the members object
        return Object.entries(members).flatMap(([memberKey, member]) => {
            const result = [];
            const dobValue = member?.dateOfBirth.value;
            if (dobValue) {
                result.push({
                    label: 'Date of Birth',
                    value: dobValue,
                });
            }
            const coverAmountValue = member?.coverAmount.value;
            if (coverAmountValue !== null) {
                result.push({
                    label: 'Cover Amount',
                    value: coverAmountValue,
                });
            }

            return result;
        });
    };
    const meAndmyFamily = getAdditionalMembers(KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY);
    const parentsinLaws = getAdditionalMembers(KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS);
    const extendedFamily = getAdditionalMembers(KMF_COVER_CATEGORIES.EXTENDED_FAMILY);
    const benefitsKey = Object.keys(livesCovered[KMF_COVER_CATEGORIES.BENIFITS]);
    return [
        {
            title:
                meAndmyFamily?.length > 1 ? KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY : KMF_COVER_CATEGORIES.MYSELF,
            data: [...meAndmyFamily],
        },
        parentsinLaws?.length && { title: KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS, data: [...parentsinLaws] },
        extendedFamily?.length && { title: KMF_COVER_CATEGORIES.EXTENDED_FAMILY, data: [...extendedFamily] },
        benefitsKey?.length && {
            title: 'Benefits',
            data: [
                {
                    label: 'Cash back',
                    value: livesCovered[KMF_COVER_CATEGORIES.BENIFITS][benefitsKey]?.benefitsDetails?.value,
                },
            ],
        },
    ].filter((item) => item !== 0);
});

export const getLivesCoveredSummaryPayload = createSelector(getLivesCovered, (livesCovered) => {
    const getMemberSummary = (title, category) => {
        return Object.values(livesCovered[category])?.flatMap((member) => ({
            title: title,
            data: [
                {
                    label: 'Full Name',
                    value: member?.title?.value + ' ' + member?.firstName?.value + ' ' + member?.surname?.value,
                },
                {
                    label: 'Relation',
                    value: member?.relationship?.value,
                },
                {
                    label: 'Cover Amount',
                    value: 'P ' + member?.coverAmount?.value,
                },
                {
                    label: 'Premium',
                    value: member?.monthlyPremium?.value ? 'P ' + member?.monthlyPremium?.value : '-',
                },
            ],
        }));
    };
    const mainMemberTitle = Object.keys(livesCovered[KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]);
    return [
        ...getMemberSummary(
            mainMemberTitle?.length > 1 ? KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY : KMF_COVER_CATEGORIES.MYSELF,
            KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY
        ),
        ...getMemberSummary(KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS, KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS),
        ...getMemberSummary(KMF_COVER_CATEGORIES.EXTENDED_FAMILY, KMF_COVER_CATEGORIES.EXTENDED_FAMILY),
    ];
});
